/* eslint-disable */
const StatCard = ({ title, value, icon: Icon, iconBg, iconColor }) => {
  return (
    <div className="flex-1 bg-white dark:!bg-[#181819] border border-transparent dark:!border-[#3c3a3d] rounded-lg shadow-sm p-4 transition-colors">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-gray-500 dark:text-gray-400 text-sm">
            {title}
          </p>
          <p className="text-2xl font-bold text-gray-900 dark:text-white">
            {value}
          </p>
        </div>

        <div
          className={`w-12 h-12 ${iconBg} rounded-lg flex items-center justify-center`}
        >
          <Icon className={`w-6 h-6 ${iconColor}`} />
        </div>
      </div>
    </div>
  );
};

export default StatCard;
